import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPeace: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="peace"><circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><path d="M12 12L5.75 18.25" stroke="currentColor" strokeWidth="1.5"/><path d="M12 12L18.25 18.25" stroke="currentColor" strokeWidth="1.5"/><path d="M12 3V21" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconPeace;
